<template>
    <div id="madForm" ref="madForm" @submit.prevent="submitForm">
        <form v-if="loaded" :id="form.id">
            <scheduling-form v-if="isScheduling"></scheduling-form>
            <default-form v-else></default-form>
            <ReCaptcha v-if="expectCaptcha" />
        </form>
    </div>
</template>

<script>
  import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
  import FormField from './FormField';
  import DefaultForm from './DefaultForm.vue';
  import SchedulingForm from './SchedulingForm.vue';
  import formMixin from '../mixins/formMixin';
  import paymentsMixin from '../mixins/paymentsMixin';
  import defaultMixin from '../mixins/defaultMixin';
  import ReCaptcha from './fields/ReCaptcha';

  export default {
    mixins: [formMixin, paymentsMixin, defaultMixin],
    data() {
      return {
        errors: [],
        height: '',
        customer: '',
      };
    },
    methods: {
      ...mapMutations({
        addField: 'addField'
      }),
      ...mapMutations('form', { setFormId: 'setFormId', setConfirmed: 'setConfirmed', setSubmitted: 'setSubmitted', setSubmissionError: 'setSubmissionError', setCsrf: 'setCsrf' }),
      ...mapActions('form', { getForm: 'getForm' }),
      async submitForm(event) {
          event.preventDefault();
          this.setSubmitted(true);

          // Form validation
          const children = this.$children[0].$children;
          this.validateOnTouch(children);
          const formWithError = this.hasError(children);
          if (formWithError === true) {
            this.setSubmitted(false);
            return;
          }

          // TODO: this needs to be better structured
          if (!this.stripe || this.stripe.paymentRequired === false) {
              var self = this;
              this.postForm(event).then(() => {
                self.populateCsrf();
              }).catch(() => {
                self.populateCsrf();
              });
          } else if (this.stripe.cardEmpty || this.stripe.dateEmpty || this.stripe.cvcEmpty) {
              this.addCreditCardError('Missing required card information.');
              this.setSubmitted(false);
          } else {
              let self = this;
              let cc = self.$store.getters.response[self.creditCardField.id];
              this.postHandlePayment(cc).then(function (response) {
                 self.populateCsrf().then(() => {
                   if (!response.customer || !response.paymentIntent) {
                       self.addCreditCardError(response.message ? response.message : 'Failed to process card.');
                       self.setSubmitted(false);
                   } else {
                       let cc = self.$store.getters.response[self.creditCardField.id];
                       cc.value.customerId = response.customer.id;
                       cc.value.paymentIntent = true;

                       let secret = response.paymentIntent.secret;

                       self.confirmPayment(secret, cc).then(function (result) {
                          if (result.paymentIntent) {
                              cc.value.paymentIntent = result.paymentIntent.id;
                              cc.value.status = result.paymentIntent.status;
                              self.addField(cc);
                              self.postForm(event);
                          } else if (result.error) {
                              self.addCreditCardError(self.errorFromStripe(result.error.type, result.error.message));
                              self.setSubmitted(false);
                          } else {
                              self.addCreditCardError(self.errorFromStripe('default'));
                              self.setSubmitted(false);
                          }
                       });
                   }
                 });
              });
          }
        },

        /**
         * Returns the first and last component of a name as a tuple
         *
         * @param {string} name
         */
        splitName(name) {
            let firstName = '';
            let lastName = '';
            let parts = name.split(' ');

            if (parts.length === 1) {
                firstName = parts[0];
            } else if (parts.length > 1) {
                firstName = parts.slice(0, -1).join(' ') || '';
                lastName = parts.slice(-1).join(' ');
            }

            return [firstName, lastName];
        },

        /**
         * Filter out empty object values
         *
         * @param {*} obj
         */
        removeEmptyValuesFromObject(obj) {
            return Object.fromEntries(
                Object.entries(obj).filter(function (v) {
                    return v[1] != null && v[1].length > 0;
                })
            )
        },
      },
      created() {
        this.setFormId(this.$route.params.id);

        var self = this;
        this.getForm({sig: this.sig, domain: this.domain}).then(() => {
          self.populateCsrf();
        });
      },
      computed: {
        ...mapGetters({
          formErrors: 'fieldsWithErrors',
          userInput: 'response',
          sig: 'sig',        }),
        ...mapGetters('form', [
          'fields',
          'redirect',
          'inline_title',
          'inline_message',
          'nameFieldIds',
          'validateCaptcha',
          'csrf',
          'fieldByIntegrationFieldId',
          'domain'
        ]),
        ...mapState('form', {
            form: 'form',
            formId: 'formId',
            confirms: 'confirmed'
        }),
        ...mapState('payments', { stripe: 'stripe' }),
        loaded() {
          return this.form != null && this.form.integration != undefined;
        },
        isScheduling() {
          return this.form.integration == 'scheduling';
        },
      },
      updated() {
        this.height = this.$refs.madForm.clientHeight;
      },
      components: {
        FormField,
        DefaultForm,
        SchedulingForm,
        ReCaptcha
      },
  };
</script>

<style>
    .disabled {
        cursor: not-allowed;
    }
    .description {
        word-break: break-word;
    }
    input[type="text"],input[type="email"],input[type="tel"] {
        height: 48px;
        margin: 12px 0 0;
        padding: 16px 20px;
        border-radius: 5px;
        border: solid 1px #dddedf;
        background-color: #ffffff;
    }
    .payments.form-group {
        margin-top:1rem;
        margin-bottom:2rem;
    }
    .payments .madform-label-wrapper label {
        font-weight:600;
    }
    .payments-quantity {
        float: right;
        margin-left:1.6;
        border: 0;
        width:auto;
        height:auto;
        margin-right:0;
        padding-right:0;
    }
    .payments-quantity .form-control {
        width: 3.75rem;
        height:3rem;
        margin-left:1em;
        margin-right:0;
        padding-right:0;
    }
    .payments-quantity span, .payments-quantity .form-control {
        display:inline-block;
    }
    .payments-single-product-field-wrapper label {
        font-size:16px;
        font-weight:600;
        line-height:1.25;
    }
    .payments .form-text {
        font-size:14px;
        line-height:1.43;
        font-weight: normal;
        color:#24282f!important;
    }
    .payments-user-defined-field-wrapper input {
        width:auto;
    }
    .payments-list-field-row label {
    }
    .with-quantity .payments-list-field-row {
        display:flex;
        align-items: center;
        justify-content: center;
        justify-content: space-between;
        height:3.75rem;
        border-bottom: 1px solid #f0f0f0;
    }
    .with-quantity .payments-list-field-row .form-check-input {
        position: relative;
        margin-right: .3rem;
    }
    .payments-list-field-row .payments-quantity {
        float:none;
        min-width:108px;
    }
    .with-quantity .payments-list-field-row:last-child, .payments-list-field tr:last-child td {
        border-bottom: 0;
    }
    .payments-list-field table {
        width:100%;
    }
    .payments-list-field td {
        height:3.75rem;
        border-bottom: 1px solid #f0f0f0;
        vertical-align: middle;
    }
    .payments-credit-card .extra-cc-data {
        width: 100%;
    }
    .payments-credit-card .extra-cc-data td {
        padding-right:25px;
    }
    .payments-credit-card .extra-cc-data td:last-child {
        padding-right:0;
    }
    .madform-submit {
        transition: all 0.3s ease;
    }
    .madform-submit:hover {
        opacity: 0.8;
    }
    @media only screen and (max-width: 460px) {
        .credit-card-cvc-column, .credit-card-exp-column, credit-card-zip-column {
            flex-basis: auto;
        }
    }
    @media only screen and (max-width: 415px) {
        #madForm {
            padding: 1rem;
        }
    }
</style>
